var _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.192 10.4385L18.3564 8.60285C18.1663 8.41276 17.8581 8.41276 17.668 8.60285L15.7367 10.5342L18.2607 13.0582L20.192 11.1269C20.3821 10.9368 20.3821 10.6286 20.192 10.4385ZM8.38799 17.8828L14.7041 11.5667L17.2282 14.0908L10.9121 20.4069C10.634 20.685 10.2555 20.8391 9.86231 20.8345L7.9825 20.8124L7.96038 18.9326C7.95576 18.5394 8.10992 18.1609 8.38799 17.8828ZM11.9446 21.4395L18.2607 15.1234L18.2608 15.1234L19.2933 14.0908L19.2933 14.0908L21.2246 12.1595C21.985 11.3991 21.985 10.1663 21.2246 9.40597L19.3889 7.57028C18.6286 6.80991 17.3958 6.80991 16.6354 7.57028L7.35541 16.8503C6.79928 17.4064 6.49095 18.1633 6.5002 18.9498L6.5391 22.2558L9.84513 22.2947C10.6316 22.3039 11.3885 21.9956 11.9446 21.4395ZM14.1181 21.0398C13.7148 21.0398 13.3879 21.3667 13.3879 21.7699C13.3879 22.1732 13.7148 22.5001 14.1181 22.5001L21.9063 22.5001C22.3095 22.5001 22.6364 22.1732 22.6364 21.7699C22.6364 21.3667 22.3095 21.0398 21.9063 21.0398L14.1181 21.0398Z",
    fill: "#5F6272"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDo);
export default __webpack_public_path__ + "static/media/Do.342314e3a91c92331b2a1278dbc4bcfa.svg";
export { ForwardRef as ReactComponent };